export default "__VITE_ASSET__BerCnwCL__"